import BaseComponent from "../../../../lib/components/BaseComponent";
import CM from "../../../model/system/CM";
import cner_config from "../../../../cner.config";
import ChangelogButton from "./changelog/ChangelogButton";

class Nav extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  render() {
    let logoIcon;
    logoIcon = <img src={require('./img/logo-cner-weiss.png')} alt="logo" className="h-[60px] w-[51px]"/>;

    return <div className={'flex items-end gap-1 fixed top-3 left-3 z-10 justify-between w-full'}>
      <div className='flex items-end'>
        <div>{logoIcon}</div>
        <span className='font-cn-gotham-bold text-slate-50 text-4xl'>{cner_config[CM.get().developer].cner_nav_logo_text}</span>
      </div>
      <div>
        <ChangelogButton />
      </div>
    </div>
  }
}

export default Nav;
